import component from './breadcrumb.component'
import service from './breadcrumb.service'

const module = angular.module('breadcrumb', [])

module.component('breadcrumb', component).factory('breadcrumbService', service)

export default module.name
